'use client'

import { memo, useMemo } from 'react'
import { IconCheck, IconChevronRight } from '@tabler/icons-react'
import clsx from 'clsx'
import { isNotNil } from 'ramda'

import { Promotion } from 'modules/products'
import { theme } from 'shared/ui/utils/designTokens'

import { ActivePromotionState , PromotionType } from '../../../types'

import styles from './SpecialPromotionLabel.module.scss'

const SpecialPromotionLabel = memo(
  ({
    promotion,
    source,
    notClickable,
    isActivePromotion,
    activePromotion,
    onClick
  }: {
    promotion: Promotion
    source?: string
    notClickable?: boolean
    isActivePromotion: boolean
    activePromotion: ActivePromotionState | null
    onClick: (event: React.MouseEvent) => void
  }) => {
    const iconSize = useMemo(
      () => (source === 'product_page' ? 12 : 6),
      [source]
    )

    const isProductPage = source === 'product_page'
    const contentClassName = clsx(
      styles.content,
      isProductPage && styles.contentProductPage
    )

    if (isActivePromotion)
      return (
        <button
          className={clsx(styles.buttonActive, isProductPage && styles.buttonProductPage)}
          onClick={!notClickable ? onClick : undefined}
        >
          <div className={styles.icon}>
            <IconCheck
              color={theme.colors.brand.primary}
              height={iconSize}
              width={iconSize}
            />
          </div>
          <span className={contentClassName}>
            {activePromotion?.type === PromotionType.FREE_DELIVERY ? (
              <>Promocja aktywna: Dostawa gratis</>
            ) : (
              <>
                Promocja aktywna:{' '}
                {isNotNil(activePromotion?.quantity) &&
                activePromotion?.quantity
                  ? `${activePromotion.quantity} ${
                      activePromotion.quantity > 1 ? 'razy' : 'raz'
                    }`
                  : ''}
              </>
            )}
          </span>
        </button>
      )
    else
      return (
        <button
          className={clsx(styles.button, isProductPage && styles.buttonProductPage)}
          onClick={!notClickable ? onClick : undefined}
        >
          <span className={contentClassName}>
            {promotion.name}
          </span>
          <div className={styles.icon}>
            <IconChevronRight size={16} />
          </div>
        </button>
      )
  }
)

export default SpecialPromotionLabel

